import { CONTACTS_PATH } from 'bank-contacts/src/constants'
import { Contact } from 'commons/types/DTO/bank/companyDetails/contact'
import { CheckMark, UsPhoneLabel } from 'ui/components'
import { Icon, IconName, IconSize } from 'ui/components/Icon'
import { TableActions, TableColumn } from 'ui/components/Table'
import { Tooltip } from 'ui/components/Tooltip'

import { NameLink } from './styles'

export const columns = (
  onDelete: (item: Contact) => void,
  setEditContact: (item: Contact) => void
): TableColumn<Contact>[] => [
  {
    align: 'left',
    title: 'Name',
    render: (item) => (
      <NameLink to={`${CONTACTS_PATH}/${item.id}`}>
        {item.name}
        {item.isShared && (
          <Tooltip id={`shared${item.id}`} type="dark" content="Shared" event="hover">
            <Icon name={IconName.SHARED} size={IconSize.XS} />
          </Tooltip>
        )}
        {item.isDocuments && (
          <Tooltip id={`documents${item.id}`} type="dark" content="Documents" event="hover">
            <Icon name={IconName.DOCUMENT} size={IconSize.XS} />
          </Tooltip>
        )}
        {item.isFinancials && (
          <Tooltip id={`financials${item.id}`} type="dark" content="Financials" event="hover">
            <Icon name={IconName.FINANCIALS} size={IconSize.XS} />
          </Tooltip>
        )}
      </NameLink>
    )
  },
  {
    title: 'Title',
    key: 'title'
  },
  {
    align: 'center',
    title: 'Email',
    key: 'email'
  },
  {
    align: 'center',
    title: 'Phone',
    render: ({ phone }) => <UsPhoneLabel value={phone} />
  },
  {
    title: 'Owner (Ownership %)',
    render: ({ isOwner, ownerPercentLabel }) => isOwner && <CheckMark value rounded label={ownerPercentLabel} />
  },
  {
    title: 'Debtholder',
    render: ({ isDebtholder }) => isDebtholder && <CheckMark value rounded label="" />
  },
  {
    title: 'Account Signer',
    render: ({ isAccountSigner }) => isAccountSigner && <CheckMark value rounded label="" />
  },
  {
    title: 'Actions',
    align: 'center',
    width: '50px',
    render: (item) => (
      <TableActions
        items={[
          {
            type: 'edit',
            onClick: () => setEditContact(item)
          },
          {
            type: 'option',
            title: 'Disconnect',
            onClick: () => onDelete(item)
          }
        ]}
      />
    )
  }
]
